import React, { useRef, useEffect, useState, useContext } from 'react';
import { object } from 'prop-types';
import { QueryProvider, useDataModel, QueryContext } from '@thd-nucleus/data-sources';
import { ExperienceContext, useStoreId } from '@thd-nucleus/experience-context';
import { Aisle } from './subcomponents/Aisle';
import { dataModel } from './dataModel';

const DynamicBroadIntentAisle = ({
  keyword,
  storeId: _searchStoreId,
  searchResponse
}) => {
  let aisles = [];
  const storeId = useStoreId();
  const loadedStoredId = useRef(storeId);
  const { channel } = useContext(ExperienceContext);
  const { isClientResolved } = useContext(QueryContext);
  const isMobile = channel === 'mobile';

  let { data, error, loading, variables } = useDataModel('searchModel', {
    variables: {
      keyword,
      storeId: _searchStoreId || storeId,
    },
    skip: !!searchResponse
  });

  if (searchResponse) {
    ({ data, loading, error, variables } = searchResponse);
  }

  if (!data) {
    return null;
  }

  if (data?.searchModel && !loading) {
    loadedStoredId.current = variables.storeId;
    aisles = data.searchModel.aisles;
  }

  const skipFn = ({ skip, queryName, attributes }) => {
    if (queryName !== 'product') return skip;
    const isResolved = isClientResolved({ queryName: 'searchModel' });

    if (attributes.product.fulfillment) {
      if (isResolved) return skip;
      return true;
    }
    return skip;
  };

  return (
    (aisles || []).map((aisle, index) => {
      let _aisle = aisle.aisle.filter((category) => {
        return category.products && category.products.length > 0;
      });
      if (_aisle.length === 0) return null;
      return (
        <QueryProvider
          cacheKey="dynamic-aisles"
          key={index}
          skip={skipFn}
          defaultVariables={{ storeId: loadedStoredId.current }}
          dataSource="searchNavAisle"
        >
          <Aisle
            isMobile={isMobile}
            aisle={aisle}
            storeId={loadedStoredId.current}
            key={`aisle-${aisle.aisleBrand}-${index}`}
          />
        </QueryProvider>
      );
    }));
};

DynamicBroadIntentAisle.displayName = 'DynamicBroadIntentAisle';
DynamicBroadIntentAisle.dataModel = dataModel;
DynamicBroadIntentAisle.props = {
  variables: object
};

export { DynamicBroadIntentAisle };
